/** Copy for the platform's ticket words. An unknown word renders as itself rather than vanishing. */
export function ticketStatusLabel(status: string): string {
  const labels: Record<string, string> = {
    OPEN: "Open",
    IN_PROGRESS: "In progress",
    AWAITING_INFO: "Waiting for you",
    RESOLVED: "Resolved",
    CLOSED: "Closed",
  };
  return labels[status] ?? status;
}

export function ticketStatusScheme(status: string): "warning" | "success" | "info" {
  if (status === "AWAITING_INFO") return "warning";
  if (status === "RESOLVED" || status === "CLOSED") return "success";
  return "info";
}

export const PRIORITIES = [
  { value: "HIGH", label: "High · work has stopped" },
  { value: "MEDIUM", label: "Medium · work continues with difficulty" },
  { value: "LOW", label: "Low · a question or a minor issue" },
] as const;

/** Plain text from a composer as the minimal markup the platform sanitizes and stores. */
export function textToHtml(text: string): string {
  return text
    .split(/\n{2,}/)
    .map((p) =>
      p.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br>"),
    )
    .map((p) => `<p>${p}</p>`)
    .join("");
}
